import React from 'react';
import { Chip } from '@mui/material';
import getSessionTypeLabel from '../../../Sessions/sessionTypeLabel';

const SessionTypeChip = ({ session }) => {
  const label = getSessionTypeLabel(session);
  if (!label) return null;
  return (
    <Chip
      label={label}
      size="small"
      color={session.isBasic ? 'default' : 'secondary'}
      sx={{ ml: 0.5, height: 18, fontSize: 11 }}
    />
  );
};

export default SessionTypeChip;
